<template>
  <transition name="fade">
    <div
      class="flex items-center justify-between p-4 desktop:px-6 text-gray-900"
      :class="{
        'bg-errorBg': type === AlertType.ERROR,
        'bg-success': type === AlertType.SUCCESS,
        'bg-warning': type === AlertType.WARNING
      }"
    >
      <span class="mr-2 leading-tight">{{ msg }}</span>
      <lm-icon-button icon="close" svg svg-size="20" @click="$emit('close')" />
    </div>
  </transition>
</template>

<script>
import {Alert as AlertType} from '@/lib/definitions'
import LmIconButton from '@/components/ui/LmIconButton'

export default {
  name: 'LmAlert',
  components: {LmIconButton},
  props: {
    msg: {
      type: String,
      default: 'Generic error'
    },
    type: {
      type: String,
      default: AlertType.ERROR
    }
  },
  data() {
    return {
      AlertType
    }
  }
}
</script>
